<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
      <v-card-text>
        <v-layout column>
          <v-flex v-html="text">
        </v-flex>
        <v-layout row wrap>
        <v-flex>
          <v-text-field
            label="Номер оферты"
            hint=""
            v-model="agreementNumber"
            :rules="[v=>!!v || 'номер должен быть указан']"            
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Дата оферты"
            :rules="[v=>!!v || 'дата должна быть указана']"
            hint=""
            v-model="agreementDate"
          >
          </v-date-field>  
        </v-flex>      
        </v-layout>
      </v-layout>
      </v-card-text>
    </v-form>
    <template #actions>
      <v-btn :disabled="!valid" @click="add">Направить</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'post-offer-cancel-form',
    components: {vDateField, vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      agreementDate: ''
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        chat: 'getChatterChat',
        profile: 'getProfile'
      }),
      partnerName () {
        return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]'
      },
      partnerInn () {
        return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]'
      },
      clientName () {
        return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]'
      },
      clientInn () {
        return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]'
      },
      expiryTime () {
        return this.item.expiryTime ? 'Срок действия настоящей оферты по ' + formats.formatDate(moment(this.item.expiryTime)) + '.' : ''
      },
      docLink () {
        return this.item.link ? this.item.link : ''
      },
      title () {
        return 'Направить отмену оферты'
      },
      text: {
        get () {
          return this.getText()
        }
      }
    },
    methods: {
      add () {
        if (this.$refs.form.validate()) {
          this.item.text = this.getText()
          this.item.chatId = this.chat.id
          this.$store.dispatch('addChatterPost', this.item)
          this.edit = false
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          chatId: null,
          text: '',
          typeCode: 'OFFER_CANCEL',
          link: null
        }
      },
      getText () {
        return `${this.clientName}, ИНН ${this.clientInn} отменяет оферту № ${this.agreementNumber} от ${formats.formatDate(this.agreementDate)} направленную ${this.partnerName}, ИНН ${this.partnerInn}`
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PostOfferCancelForm.vue?95ea465a